import React, { useRef, useEffect, useState } from "react";
import logo from "../../assets/images/pats-logo.svg";
import plus from "../../assets/images/plus.png";
import notification from "../../assets/images/notification.png";
import bluenotification from "../../assets/images/bluenotification.png";
import down from "../../assets/images/down.png";
import profile from "../../assets/images/profile.jpg";
import { NavLink, useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Notification from "./notification";
import SearchBar from "./search";
import $ from "jquery";

function Header(props) {
  const [userName, setUserName] = useState("User");
  const [userImage, setUserImage] = useState("");
  const [open, setOpen] = useState(false);
  const [notiCount, setNotiCount] = useState();
  const [openSearch, setOpenSearch] = useState(false);
  const [updatedNoticount, setUpdatedNoticount] = useState();
  const [searchResponse, setSearchResponse] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [hide, setHide] = useState("");
  const [inputValue, setInputValue] = useState("");
  let history = useHistory();
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const [userID, setUserID] = useState(1);
  let params = useParams();
  useOutsideAlerter(wrapperRef);
  useEffect(() => {
    setOpenSearch(false);
    setOpen(false);
    setInputValue("");
  }, [params]);
  useEffect(() => {
    var result = window.localStorage.getItem('noticount_0');

    if (result == "true") {
      // $(".hd-notif-count").css("display","none");


    }
    //Get username and image from localstorage
    if (localStorage.getItem("pats_login") !== null) {
      var pats_login = JSON.parse(localStorage.getItem("pats_login"));
      setUserName(pats_login.userName);
      //UserID for Navlink
      setUserID(pats_login.userID);
      if (pats_login.userImage !== null && pats_login.userImage !== "") {
        setUserImage(pats_login.userImage);
      } else {
        setUserImage("no-img.png");
      }
    }
  }, []);
  const uid = userID;


  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if ((ref = wrapperRef)) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        if ((ref = searchRef)) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpenSearch(false);
            // setSearchText(txt);
          }
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const handleUserInput = (e) => {
    setInputValue(e.target.value);
    searchOnChange(e.target.value);
  };

  function LogoutUser() {
    fetch(process.env.REACT_APP_API_URL + "api/user/logout")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          // localStorage.removeItem("noticount_0");
          localStorage.removeItem("pats_login");
          history.push("/tab");
        }
      });
  }
  function FetchMoreData() {
    fetch(process.env.REACT_APP_API_URL + "api/posts/notificount")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          //    console.log("yess",data)
          setNotiCount(data.noticount);
          //    $(".hd-notif-count").css("display","block");

        }
      });

  }
  // function FetchTime(){
  //   fetch(process.env.REACT_APP_API_URL + "api/posts/" + limit + "/0")
  // }
  useEffect(() => {
    FetchMoreData();
    //FetchTime()
    const interval = setInterval(() => {
      FetchMoreData();
      //FetchTime()
    }, 10000);
    return () => clearInterval(interval);


  }, []);

  function searchOnChange(txt) {
    setSearchText(txt);
    if (txt !== "") {
      setOpenSearch(true);
      setSearchResponse("loading");
      fetch(process.env.REACT_APP_API_URL + "api/user/search/" + txt)
        .then((response) => response.json())
        .then((data) => {
          if (data.issuccessful == true) {
            setSearchResponse(data.search);
          }
        });
    } else {
      setOpenSearch(false);
      setSearchResponse([]);
    }
  }


  const handleNotiCount = () => {
    setOpen(!open);
    // let updateData = $parsedBody["userID"];
    fetch(process.env.REACT_APP_API_URL + "api/posts/notificountupdate", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(() => {
        //console.log('test')
        fetch(process.env.REACT_APP_API_URL + "api/posts/notificount")
          .then((response) => response.json())
          .then((data) => {
            if (data.issuccessful == true) {
              //    console.log("yess",data)
              setNotiCount(data.noticount);
              //    $(".hd-notif-count").css("display","block");

            }
          });
      });
  };

  const [isOpen, setIsOpen] = useState(false);
  const handleDropdown = () => {
    setIsOpen(true);
  };

  return (
    <header className="header-main">
      <div className="header-wrap">
        <div className="hd-container">
          <div className="hd-flex">
            <div className="hd-logo">
              <div
                className="hd-menu-toggle"
                onClick={() => props.setMenuToggle(!props.menuToggle)}
              >
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
              </div>
              <NavLink to={"/home"}>
                <img src={logo} alt="logo" />
              </NavLink>
            </div>
            <div className="hd-search" ref={searchRef}>
              <input
                className="hd-search-input"
                type="text"
                placeholder="Search i2e Consulting"
                value={inputValue}
                onChange={handleUserInput}
              />
              {openSearch ? (
                <SearchBar data={searchResponse} txt={searchText} />
              ) : null}
            </div>
            <div
              className="hd-profile"
              onClick={handleDropdown}
              ref={wrapperRef}
            >
              <NavLink to={"/profile/" + uid}>
                <div className="hd-pro-wrap">
                  
                  <img
                    className="hd-pro-img bg-img"
                    src={
                      process.env.REACT_APP_IMG_URL +
                      (userImage != '' ? userImage : "no-img.png")
                    }
                    onError={(e)=>{
                      e.currentTarget.src = process.env.REACT_APP_IMG_URL + 'no-img.png';
                      e.currentTarget.onerror = null;
                    }}
                  />
                  <p className="hd-pro-name">{userName}</p>
                </div>
              </NavLink>
              <div className="hd-controls">
                {/* <div className="hd-con-item">
                  <div class="hd-con-sample">
                    <img className="hd-con-item-img" src={plus} alt="plus" />
                  </div>
                </div> */}
                <div className="hd-con-item" ref={wrapperRef} onClick={handleNotiCount}>
                  <div className="hd-con-sample"
                  // onClick={() => setOpen(!open)}

                  >
                    {" "}
                    <img
                      className="hd-con-item-img"
                      src={!open ? notification : bluenotification}
                      alt="notification"
                    />
                  </div>

                  <div
                    className={` hd-notif ${notiCount !== 0 ? "hd-notif-count" : null
                      }`}
                  >
                    {notiCount !== 0 ? notiCount : null}
                  </div>
                  {open ? <Notification /> : null}
                </div>
                {/* <div className="hd-con-item hd-logout">
                  <div className="hd-con-sample">
                    <img
                      className="hd-down-img hd-con-item-img"
                      src={down}
                      alt="down"
                    />
                  </div>
                  <div className="hd-con-logout" onClick={LogoutUser}>
                    <p>Logout</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
